import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentStore } from '@modules/company-page/store/company-stores';

@Component({
  selector: 'pub-store-info',
  templateUrl: './store-info.component.html',
  styleUrls: ['./store-info.component.scss'],
})
export class StoreInfoComponent {
  $currentStore = this.store.select(selectCurrentStore);

  constructor(private store: Store) {}
}
